import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparison } from '../../data/kit';
import { CtaButton } from '../ui/CtaButton';
import { Highlight, SectionHeading } from '../ui/SectionHeading';
export function ClosingSection() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-29" data-mp="cms0t9gher85">
      <div className="mx-auto max-w-[1080px] px-5 sm:px-8" data-id="element-30" data-mp="hiz6r28vo2q3">
        <SectionHeading title={<>
              Stop rebuilding. Start with <Highlight data-id="element-32" data-mp="3qapo684atce">a ready unit.</Highlight>
            </>} description="Three complete fall units and five bonuses — plan, story, cards, activities, data sheets and home practice, organized and printable." data-id="element-31" data-mp="hllfv6bf2qaf" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-33" data-mp="3uxviyaxau82g">
          <div className="rounded-2xl border border-line bg-cream p-6 sm:p-8" data-id="element-34" data-mp="3uwc1wi3tjszm">
            <h3 className="font-display text-2xl font-extrabold uppercase text-slate" data-id="element-35" data-mp="3gzp4ke7yf0t6">Without Speech Therapy Ready</h3>
            <ul className="mt-5 divide-y divide-line" data-id="element-36" data-mp="3l2bpdv67jlgv">
              {comparison.map(row => <li key={row.without} className="flex items-start gap-3 py-3.5 text-[15px] text-slate" data-id="element-37" data-mp="2mtqk0pgwnjqp">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-slate/70" aria-hidden="true" data-id="element-38" data-mp="2hv6tebrd9js0" />
                  {row.without}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl bg-petrol p-6 shadow-lift sm:p-8" data-id="element-39" data-mp="2rp5vjarfx3jy">
            <h3 className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-40" data-mp="241xtd1pb6am5">
              With <span className="text-teal-light" data-id="element-41" data-mp="1z3w767wl5v6g">Speech Therapy Ready</span>
            </h3>
            <ul className="mt-5 divide-y divide-white/10" data-id="element-42" data-mp="2ds0rfgbaeerc">
              {comparison.map(row => <li key={row.with} className="flex items-start gap-3 py-3.5 text-[15px] font-medium text-white" data-id="element-43" data-mp="28zqxzqayqwkb">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal-light" strokeWidth={3} aria-hidden="true" data-id="element-44" data-mp="1l93m6txxfmsh" />
                  {row.with}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex justify-center" data-id="element-45" data-mp="2a1knztth4zr1">
          <CtaButton href="#offer-details" className="w-full max-w-[420px] sm:w-auto" data-id="element-46" data-mp="2a09hhm8n9dw8">Get the starter kit</CtaButton>
        </div>
      </div>
    </section>;
}